import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-validation-warning-modal',
  components: {},
})
export default class ValidationWarningModal extends Vue {
  @Prop({ type: String, required: true }) readonly entityName: string;
  @Prop({ type: String, default: 'validation-warning-confirmation-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop() readonly warningMessages;

  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  get modalTitle() {
    return this.$t('global.modals.validation-warning.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get modalBody() {
    return this.$t('global.modals.validation-warning.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  closeModal() {
    this.$emit('close-modal');
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onContinue() {
    this.$emit('continue-clicked');
  }

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
